import { CommonModule, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-read-more',
  standalone: true,
  imports: [CommonModule],

  templateUrl: './read-more.component.html',
  styleUrl: './read-more.component.css',

})
export class ReadMoreComponent {

  //    @Input() text: string = '';
  //   @Input() limit: number = 60;

  //   isExpanded = false;
  //   get limitHeight(): number {
  //     return 0; // approx height in px for 100 characters (adjust if needed)
  //   }

  //   toggleDic() {
  //     this.isExpanded = !this.isExpanded;
  //   }
  // }


  @Input()
  content!: string;
  @Input()
  limit!: number;
  @Input()
  completeWords!: boolean;

  isContentToggled!: boolean;
  nonEditedContent!: string;

  constructor() { }

  ngOnInit(): void {

    this.nonEditedContent = this.content;
    this.content = this.formatContent(this.content);
  }
  toggleContent() {
    this.isContentToggled = !this.isContentToggled;
    this.content = this.isContentToggled ? this.nonEditedContent : this.formatContent(this.content);

  }

  formatContent(content: string) {
    if (this.completeWords) {
      this.limit = content.substr(0, this.limit).lastIndexOf(' ');
    }
    return `${content.substr(0, this.limit)}...`;
  }
}
